import type { ProductLineupProps } from '@/components/sections/einstein/product/lineup';
import type { IMY24ProductExteriorInterior } from '@/components/sections/my24/product/exterior-interior-x-series';
import type { ProductHeroBannerXSeriesProps } from '@/components/sections/my24/product/hero-banner-x-series';
import type { IMY24ProductNavigation } from '@/components/sections/my24/product/navigation';
import type { ProductCustomizeProps } from '@/components/shared/product-customize';
import { X_SERIES_DATA } from '@/contents/lcv/product/bluepower/shared/lineup';
import {
  getModelLineupOrderByModel,
  PRODUCT_LINEUP_DATA as SHARED_PRODUCT_LINEUP_DATA,
} from '@/contents/lcv/product/maxforce/shared/lineup';
import { DATA as SHARED_X_SERIES_DATA } from '@/contents/lcv/product/shared/x-series';

export const PRODUCT_LINEUP_DATA: ProductLineupProps = {
  menu: {
    hash: '#lineup',
    label: 'รุ่นรถอีซูซุ',
  },
  headline: {
    preTitle: 'รุ่นรถอีซูซุ',
    title: 'Model Lineup',
  },
  items: getModelLineupOrderByModel('x-series', SHARED_PRODUCT_LINEUP_DATA),
  dataTrack: {
    dataTrack: 'lcv-product',
    dataTrackSection: 'lineup',
  },
};

export const DATA = {
  META_TAG_DATA: {
    ...SHARED_X_SERIES_DATA.META_TAG_DATA,
  },
  PRODUCT_HERO_BANNER_DATA: {
    ...SHARED_X_SERIES_DATA.PRODUCT_HERO_BANNER_DATA,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    items: SHARED_X_SERIES_DATA.PRODUCT_HERO_BANNER_DATA.items.map((item) => ({
      ...item,
      buttons: [
        {
          label: 'สนใจรถ',
          border: true,
          isMinWidth: true,
          color: 'button-white',
        },
      ],
    })),
  } satisfies ProductHeroBannerXSeriesProps,
  PRODUCT_VIDEO_DATA: {
    ...SHARED_X_SERIES_DATA.PRODUCT_VIDEO_DATA,
  },
  PRODUCT_EXTERIOR_DATA: {
    ...SHARED_X_SERIES_DATA.PRODUCT_EXTERIOR_DATA,
    tabs: SHARED_X_SERIES_DATA.PRODUCT_EXTERIOR_DATA.tabs?.map((tab) => ({
      ...tab,
      headline: {
        ...tab.headline,
        buttons: [],
      },
    })),
  } as IMY24ProductExteriorInterior,
  PRODUCT_INTERIOR_DATA: {
    ...SHARED_X_SERIES_DATA.PRODUCT_INTERIOR_DATA,
    tabs: SHARED_X_SERIES_DATA.PRODUCT_INTERIOR_DATA.tabs?.map((tab) => ({
      ...tab,
      headline: {
        ...tab.headline,
        buttons: [],
      },
    })),
  } as IMY24ProductExteriorInterior,
  PRODUCT_CUSTOMIZE_DATA: {
    ...SHARED_X_SERIES_DATA.PRODUCT_CUSTOMIZE_DATA,
    showCalculatorButton: false,
  } as ProductCustomizeProps,
  PRODUCT_POWER_DATA: {
    ...SHARED_X_SERIES_DATA.PRODUCT_POWER_DATA,
    headline: {
      ...SHARED_X_SERIES_DATA.PRODUCT_POWER_DATA.headline,
      buttons: [],
    },
  } as IMY24ProductExteriorInterior,
  PRODUCT_SAFETY_DATA: {
    ...SHARED_X_SERIES_DATA.PRODUCT_SAFETY_DATA,
  },
  // PRODUCT_BROCHURE_DATA: {
  //   active: true,
  //   menu: {
  //     hash: '#brochure',
  //     label: 'ดาวน์โหลดโบรชัวร์',
  //   },
  //   headline: {
  //     preTitle:
  //       'ข้อมูลรุ่นรถเอ็กซ์-ซีรี่ส์ <span>รุ่นเครื่องยนต์ BLUE POWER</span>',
  //     title: 'ดาวน์โหลดโบรชัวร์',
  //   },
  //   items: [
  //     {
  //       preTitle: 'อีซูซุดีแมคซ์ EURO 4',
  //       title: 'เอ็กซ์-ซีรี่ส์',
  //       image: X_SERIES_DATA.image,
  //       brochure: X_SERIES_DATA.euro4BrochureLink,
  //     },
  //     {
  //       engineType: 'euro-5',
  //       preTitle: 'อีซูซุดีแมคซ์ EURO 5',
  //       title: 'เอ็กซ์-ซีรี่ส์',
  //       image: X_SERIES_DATA.image,
  //       brochure: X_SERIES_DATA.brochure,
  //     },
  //   ],
  // } as BrochureDownloadProps,
  PRODUCT_LINEUP_DATA,
  PRODUCT_NAVIGATION_DATA: {
    active: true,
    // theme: 'dark',
    // isTransparent: true,
    title: X_SERIES_DATA.label,
    price: X_SERIES_DATA.price,
    buttons: [
      {
        label: 'สนใจรถ',
        color: 'button-red',
        size: 'md',
        isMinWidth: true,
      },
    ],
  } as IMY24ProductNavigation,
};
